import {
  Checkbox,
  FieldMessage,
  Stack,
  Text,
  TextField,
  Tiles,
} from 'braid-design-system';
import { Controller, useFormContext } from 'react-hook-form';

import {} from '../../SecurityBreachForm.tsx';
import { atLeastOne } from '../validation.ts';

import {
  type FormValues,
  PRODUCTS,
  type Product,
} from '#src/pages/manage/security-breach/SecurityBreach.tsx';

export const ProductsImpacted = () => {
  const { getValues, setValue } = useFormContext<FormValues>();
  return (
    <Controller
      name="productsImpacted"
      rules={{
        validate: atLeastOne('Select at least one product.'),
      }}
      render={({ field, fieldState }) => (
        <Stack space="medium">
          <Text weight="strong">Which product does it relate to?</Text>

          <Tiles columns={2} space="small">
            {(Object.keys(PRODUCTS) as Product[]).map((product) => {
              const checked = field.value.includes(product);
              return (
                <Checkbox
                  key={product}
                  id={`security-breach-products-impacted-${product
                    .replace(' ', '-')
                    .toLowerCase()}`}
                  checked={checked}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const newValue = [
                      ...field.value.filter((p: Product) => p !== product),
                      ...(e.currentTarget.checked ? [product] : []),
                    ];
                    field.onChange(newValue);
                  }}
                  label={PRODUCTS[product].displayName}
                  value={product}
                  tone={Boolean(fieldState.error) ? 'critical' : 'neutral'}
                />
              );
            })}
          </Tiles>

          {Boolean(fieldState.error?.message) ? (
            <FieldMessage
              id="security-breach-products-impacted-message"
              message={fieldState.error?.message}
              tone="critical"
            />
          ) : null}
          {getValues('productsImpacted').includes('Other') && (
            <Controller
              name="otherProduct"
              render={(nested) => (
                <TextField
                  characterLimit={255}
                  id="security-breach-products-impacted-other-text"
                  onChange={nested.field.onChange}
                  label="Specify"
                  value={nested.field.value}
                  onClear={() => setValue('otherProduct', '')}
                  message={nested.fieldState.error?.message}
                  tone={nested.fieldState.invalid ? 'critical' : undefined}
                />
              )}
            />
          )}
        </Stack>
      )}
    />
  );
};
